<script>
import PanelDetailOrder from "@/components/ordering/details/PanelDetailOrder.vue";

export default {
  name: 'DetailOrder',
  components: {PanelDetailOrder}
}
</script>

<template>
  <panel-detail-order />
</template>
